// Styles
import '../../styles/sass/fonts.scss'
import '../../styles/sass/global.scss'
import '../../styles/sass/critical.scss'




// WEBPACK FOOTER //
// ./src/assets/js/app/style-app.js